export const ROUTE_TOURNAMENT_LOBBY = '/tournaments';
export const ROUTE_ENDED_TOURNAMENTS = '/ended-tournaments';
export const ROUTE_TOURNAMENT_RESULTS = `${ROUTE_ENDED_TOURNAMENTS}/results`;
